import { render, staticRenderFns } from "./FederationSelectComponent.vue?vue&type=template&id=4f825562&scoped=true"
import script from "./FederationSelectComponent.vue?vue&type=script&lang=ts"
export * from "./FederationSelectComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f825562",
  null
  
)

export default component.exports